import React from "react";
import localizationService from "../services/localization-service.js";
import notification from "../services/notification-service.js";

export const showSmsError = (selectedlang) => {
  notification.error(() => (
    <span>
      {localizationService.getLocalizationValue("smsError", selectedlang)}{" "}
      <a href="mailto:wagonsupport@ehncanada.com">wagonsupport@ehncanada.com</a>.
    </span>
  ));
};

export function parseTimeLeftToSeconds(timeString) {
  const [hours, minutes, secondsFull] = timeString.split(":");
  const seconds = Math.floor(parseFloat(secondsFull));
  return Number(hours) * 3600 + Number(minutes) * 60 + seconds;
}

export function formatSeconds(totalSeconds) {
  const m = Math.floor(totalSeconds / 60);
  const s = totalSeconds % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}
